var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true,
      "fluid": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.breadCrumbs ? _c('v-breadcrumbs', {
          staticClass: "ml-n2 pt-2",
          attrs: {
            "items": _vm.breadCrumbs
          },
          scopedSlots: _vm._u([{
            key: "divider",
            fn: function fn() {
              return [_c('v-icon', [_vm._v("mdi-chevron-right")])];
            },
            proxy: true
          }], null, false, 3681283568)
        }) : _vm._e(), _vm.fleetId ? _c('table-wrapper', {
          attrs: {
            "headers": _vm.headers,
            "allItems": _vm.items,
            "loading": _vm.loading,
            "sortBy": "timestamp.created",
            "sortDesc": true
          },
          on: {
            "click:row": function clickRow(e) {
              return _vm.openDetail(e);
            }
          },
          scopedSlots: _vm._u([{
            key: "item.timestamp.created",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
            }
          }, {
            key: "item.ownership",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_vm._v(" " + _vm._s(item.ownership ? _vm.$t("enums.VehicleOwnershipStatusEnum.".concat(item.ownership)) : "") + " ")];
            }
          }, {
            key: "item.state",
            fn: function fn(_ref3) {
              var item = _ref3.item;
              return [item.state ? _c('v-chip', {
                attrs: {
                  "small": "",
                  "color": _vm.getState(item).color,
                  "dark": ""
                }
              }, [_vm._v(" " + _vm._s(_vm.i18n["state"][item.state]) + " ")]) : _vm._e()];
            }
          }], null, false, 772752892)
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }